/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({
    assistantId,
    messageContent,
    messageHistory,
    attachmentBlobSignedId,
  }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
      attachment_blob_signed_id: attachmentBlobSignedId,
    });
  }

  playgroundDirectUploadUrl(assistantId) {
    return `${this.url}/${assistantId}/playground_direct_uploads`;
  }

  enableSharing(assistantId) {
    return axios.post(`${this.url}/${assistantId}/enable_sharing`);
  }

  disableSharing(assistantId) {
    return axios.delete(`${this.url}/${assistantId}/disable_sharing`);
  }
}

export default new CaptainAssistant();
